/**
 * Utilitário de formatação de moeda para o padrão brasileiro.
 * @param {number} value - O valor numérico a ser formatado.
 * @returns {string} O valor formatado como moeda (Ex: R$ 1.234,56).
 */
export const formatCurrency = (value) => {
    if (value === undefined || value === null || isNaN(value)) return "R$ 0,00";
    // Tenta usar o valor como float para garantir a formatação correta
    const numericValue = parseFloat(value);

    return numericValue.toLocaleString('pt-BR', { 
        style: 'currency', 
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
    });
};

// Você pode adicionar outras funções de formatação aqui, se necessário.
